export const getConvertedCurrency = async (from: string , to: string ) => {
    console.log("api called");

    // Construct the URL with query parameters
    const url = `${process.env.REACT_APP_CURRENCY_BASE_URL}/get-conversion-rate?quote_currency=${from}&base_currency=${to}`;

    console.log("URL:", url); // Log the URL for debugging


        const response = await fetch(url, {
            method: 'GET', // Keep GET method as we're passing data in the URL
            headers: {
                'Content-Type': 'application/json',
                // Uncomment if API_KEY is needed
                // 'Authorization': `Bearer ${API_KEY}`,
            },
        });

        const jsonResponse = await response.json();
    

        if (jsonResponse.conversion_rate) {
        
       
            return jsonResponse.conversion_rate;
        }
        if (!jsonResponse.conversion_rate) {
            throw new Error(jsonResponse.message);
        }
};
